import { CrudStore } from 'core/types/crudStore'

export const getJobTitleSource = () => {
  const source = CrudStore.get('Dropdowns', 'ContactJobs')

  source.setRoot('ContactJobs')

  return source
}
